/**
 * @author EdenCha <eden@nurigo.net>
 */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import uniq from 'lodash/uniq'
import autoBind from 'auto-bind'
import { withRouter } from 'react-router-dom'

import isEqualProps from 'lib/isEqualProps'
import { bindStateToProps, bindActionCreators } from 'lib'

import ConsoleLayout from 'components/organisms/ConsoleLayout'

import { actions as usersActions } from 'store/modules/users'
import { actions as confirmActions } from 'store/modules/confirm'
import { actions as snackbarActions } from 'store/modules/snackbar'

// import config from 'config'

class ConsoleLayoutContainer extends Component {
  constructor(props) {
    super(props)
    autoBind(this)
    this.state = {
      menuOpen: false,
      favoriteMenu: []
    }
  }

  componentDidMount() {
    const drawerWrap = document.querySelector('.drawerMenuPaper')
    if (drawerWrap) {
      const scrollTop = window.sessionStorage.getItem('menuScroll') || 0
      drawerWrap.scrollTop = scrollTop
    }
    this.getFavoriteMenu()
  }

  componentDidUpdate = prevProps => {
    if (!isEqualProps(this.props, prevProps, ['preferences'])) {
      this.getFavoriteMenu()
    }
  }

  getFavoriteMenu = () => {
    const { preferences } = this.props
    const favoriteMenu = preferences?.value?.favoriteMenu || []
    this.setState({ favoriteMenu })
  }

  setFavoriteMenu = link => {
    const { UsersActions, preferences } = this.props
    const favoriteMenu = [].concat(preferences?.value?.favoriteMenu || [])
    const index = favoriteMenu.indexOf(link)
    if (index === -1) {
      favoriteMenu.push(link)
    } else {
      delete favoriteMenu[index]
    }
    return UsersActions.updateMyPreferences({
      ...(preferences?.value || {}),
      favoriteMenu: uniq(favoriteMenu).filter(d => d)
    })
  }

  drawerRef(node) {
    const drawerWrap = document.querySelector('.drawerMenuPaper')
    if (node && drawerWrap) {
      // 메뉴 스크롤 저장
      const scrollEv = _.debounce(() => {
        window.sessionStorage.setItem('menuScroll', drawerWrap.scrollTop)
      }, 50)
      drawerWrap.addEventListener('scroll', scrollEv, {
        trailing: true
      })
    }
  }

  onClickDrawerToggle() {
    this.setState({ menuOpen: !this.state.menuOpen })
  }

  onCloseDrawer() {
    this.setState({ menuOpen: false })
  }

  onClickFavoriteIcon = async (event, isFavorite, data) => {
    event.preventDefault()
    event.stopPropagation()
    const { SnackbarActions } = this.props
    const { name, link } = data
    await this.setFavoriteMenu(link)
    SnackbarActions.new({
      severity: 'info',
      message: isFavorite
        ? `${name} 메뉴 즐겨찾기를 해제했습니다. [BETA]`
        : `${name} 메뉴 즐겨찾기를 설정했습니다. [BETA]`
    })
  }

  onClickSwitchTrial = () => {
    const { ConfirmActions, history, auth } = this.props
    if (auth?.isTrial) {
      ConfirmActions.show({
        severity: 'info',
        message: '체험하기를 종료하고 실제 계정 전환페이지로 이동하시겠습니까?',
        onConfirm: () => {
          history.push('/trial/convert')
        }
      })
    }
  }

  render() {
    const { auth } = this.props
    const isAdmin = auth?.isAdmin === true
    const menus = (this.props.menus || [])
      .filter(menu => {
        return menu.admin === true ? isAdmin === true : true
      })
      .map(menu => {
        return {
          ...menu,
          list: menu.list.filter(menuItem =>
            menuItem.admin === true ? isAdmin === true : true
          )
        }
      })
    return (
      <ConsoleLayout
        menus={menus}
        menuOpen={this.state.menuOpen}
        favoriteMenu={this.state.favoriteMenu}
        routeParams={this.props.routeParams}
        layoutLoading={this.props.layoutLoading}
        auth={this.props.auth}
        theme={this.props.theme}
        children={this.props.children}
        onClickDrawerToggle={this.onClickDrawerToggle}
        onCloseDrawer={this.onCloseDrawer}
        drawerRef={this.drawerRef}
        onClickFavoriteIcon={this.onClickFavoriteIcon}
        onClickSwitchTrial={this.onClickSwitchTrial}
      />
    )
  }
}

export default connect(
  bindStateToProps({
    consoleLayout: ['menus', 'routeParams'],
    users: ['preferences']
  }),
  bindActionCreators({
    confirmActions,
    usersActions,
    snackbarActions
  })
)(withRouter(ConsoleLayoutContainer))
